import {
  CheckboxPrimitive,
  CheckboxPrimitiveProps,
} from '@reckon-web/checkbox';

import { pickSafeProps } from '../utils';

import { TableCellProps, useCellStyles } from './TableCell';

const validCheckboxKeys = ['checked', 'disabled', 'name', 'onChange'] as const;

// TODO: pretty handy, move elsewhere?
type Keys<T extends ReadonlyArray<string>> = T[number];

export type TableSelectionCellProps = { 'aria-label': string } & Pick<
  TableCellProps,
  'aria-colindex' | 'id' | 'role' | 'stickyOffset'
> &
  Pick<CheckboxPrimitiveProps, Keys<typeof validCheckboxKeys>>;

export function TableSelectionCell({
  id,
  role = 'gridcell',
  ...props
}: TableSelectionCellProps) {
  const { dataAttributes, css, style } = useCellStyles(props);
  const checkboxProps = pickSafeProps(props, ...validCheckboxKeys);
  const { 'aria-colindex': ariaColIndex, 'aria-label': ariaLabel } = props;

  return (
    <div
      id={id}
      role={role}
      css={css}
      style={style}
      aria-colindex={ariaColIndex}
      // NOTE: special data-attribute avoids confusing consumer props on `TableCell`
      data-interaction="select"
      {...dataAttributes}
    >
      <label
        css={{
          ':before': {
            content: '""',
            cursor: 'pointer',
            position: 'absolute',
            inset: 0,
          },
        }}
      >
        <CheckboxPrimitive
          aria-label={ariaLabel}
          size="small"
          {...checkboxProps}
        />
      </label>
    </div>
  );
}
